var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 258,
    x2: 512.0007,
    y2: 258,
    gradientTransform: "matrix(1 0 0 -1 0 514.0002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#45A8E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02328016,
    style: {
      stopColor: "#45A8E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2931,
    style: {
      stopColor: "#45A8E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5608,
    style: {
      stopColor: "#897FEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    style: {
      stopColor: "#C362F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C362F5"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288,433c0,18.2-14.8,33-33,33s-33-14.8-33-33c0-18.2,14.8-33,33-33S288,414.8,288,433z M188.4,92.5 c22-5,44.7-7.5,67.6-7.5c84.7,0,163.3,34.3,221.4,96.6c3.9,4.2,9.3,6.4,14.6,6.4c4.9,0,9.8-1.8,13.6-5.4c8.1-7.5,8.5-20.2,1-28.3 C440.9,83.8,351.9,45,256,45c-25.8,0-51.5,2.8-76.4,8.5c-10.8,2.4-17.5,13.1-15.1,23.9C166.9,88.2,177.6,94.9,188.4,92.5z  M275.3,181c-2,10.9,5.2,21.3,16.1,23.2c42.2,7.6,81.4,28.7,113.4,60.9c3.9,3.9,9.1,5.9,14.2,5.9c5.1,0,10.2-1.9,14.1-5.8 c7.8-7.8,7.9-20.4,0.1-28.3c-37.8-38.1-84.3-63-134.6-72.1C287.7,162.9,277.3,170.1,275.3,181z M506.1,477.9l-472-472 C26.3-2,13.7-2,5.9,5.9C-2,13.7-2,26.3,5.9,34.1l65.1,65.1c-23.8,15.4-45.7,33.9-65.6,55.1c-7.5,8.1-7.1,20.7,1,28.3 c3.9,3.6,8.8,5.4,13.6,5.4c5.4,0,10.7-2.1,14.6-6.4c19.6-21,41.5-38.9,65.3-53.4l55.1,55.1c-27.9,12.9-53.9,31.1-76.2,53.6 c-7.8,7.8-7.7,20.5,0.1,28.3c3.9,3.9,9,5.8,14.1,5.8c5.1,0,10.3-2,14.2-5.9c23-23.2,49.4-40.4,78.4-51.2l64.2,64.2 c-32.8,1.3-67.9,17-92.8,41.7c-7.8,7.8-7.9,20.4-0.1,28.3c3.9,3.9,9.1,5.9,14.2,5.9c5.1,0,10.2-1.9,14.1-5.8 c18.5-18.4,45.7-30.2,69.2-30.2h0h1.4h0c15.1,0,31.9,4.8,47.3,13.6c0.2,0.1,0.4,0.2,0.6,0.3l174.2,174.2c3.9,3.9,9,5.9,14.1,5.9 s10.2-2,14.1-5.9C514,498.3,514,485.7,506.1,477.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConnection);
export default __webpack_public_path__ + "static/media/No-connection.9f3ebbd82fbaa0998fdd5e3cc9169103.svg";
export { ForwardRef as ReactComponent };